// @flow

import type {
  RecommendationOperationsById,
} from 'hfty-operator-recommendations/types'

// Constants
import {
  OPERATIONS_TREE,
  OPERATIONS_BRANCH,
} from 'hfty-model-recommendations'

import traverse from 'fc-utils/traverse'

type RecommendationOperationsSelector = (state: Object) => RecommendationOperationsById

export default (traverse([OPERATIONS_TREE, OPERATIONS_BRANCH]): RecommendationOperationsSelector)
